<template>
  <div id="viewSchedule">
    <headNav>
      <div slot="headNavText"> {{$t('message.sch_ckjd')}}</div>
    </headNav>
    <div style="padding-top: 1.5rem"></div>
    <div class="withdraw_content">
      <div>
        <div class="withdraw_detail_title item">{{$t('message.orderId')}}:{{data.orderid.substring(0,16)}}</div>
        <div class="circle">
          <div></div>
          <div></div>
        </div>
        <div class="item">
          <div>{{$t('message.view_sc_sqje')}}</div>
          <div>{{add_comma_toThousands(data.loan_amount)}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.with_tx_dzje')}}</div>
          <div>{{add_comma_toThousands(data.real_account)}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.bill_jkqx')}}</div>
          <div>{{data.reback_day}}{{$t('message.tian')}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.bank_yhmc')}}</div>
          <div>{{userBank.bank_name}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.repay_skzh')}}</div>
          <div>{{userBank.bank_card}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.interest')}}</div>
          <div>{{data.interest}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.apply_quick_loan')}}</div>
          <div>{{add_comma_toThousands(data.apply_fee)}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.yh_manger')}}</div>
          <div>{{add_comma_toThousands(data.manage_fee)}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.view_sc_sqsj')}}</div>
          <div>{{data.loan_order_time}}</div>
        </div>
      </div>
    </div>
    <div style="width: 90%;margin: 0.6rem auto">
      <van-button block round @click="rest" id="btn">{{$t('message.view_sc_sx')}}</van-button>
    </div>

  </div>
</template>

<script>
  import {getLoanProgress,getBorrowlist,sassDetailRec,postUserInfo,getBanksNews} from '../../../ports/port'
  import headNav from "../../HeadNav/headNav";
  import {sassSearchBanksList} from "../../../ports/port";
  export default {
    name: "schedule",
    data(){
      return{
        actived:0,//已经通过的长度
        textTitle:'',
        tk:JSON.parse(localStorage.getItem("tokenAll")),
        isOrder:JSON.parse(sessionStorage.getItem('indexJH')),//获取是否有订单
        current_index:1,
        detail_list:[],
        data:{},
        loding:false,
        coin:this.$coin,
        userBank:{}
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      //获取客户的默认银行卡
      getBanksNews({userid:this.tk.userid})
        .then(res=>{
          if(res.data.code==200){
            let Arr = [];
            Arr = res.data.data.filter((el,i)=>{
              if(el.is_default==1){
                return el
              }
            });
            this.userBank = Arr[0];
          }
        });
      this.data =JSON.parse(this.$route.query.data)
    },
    components:{
      headNav
    },
    methods:{
      goBack(){
        this.$router.go(-1)
      },
      rest(){
        this.$store.commit('edit', true);//打开全局的loading
        setTimeout(()=>{
          this.$store.commit('edit', false);//关闭全局的loading
        },1000)
      },
      //金额格式转换
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        let inc = num.indexOf('.');
        if(inc==-1){
        }else{
          num=num.substring(0,inc);
        }
        var result = '';
        while (num.length > 3) {
          result = ',' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return result;
      },
    }
  }
</script>

<style scoped lang="scss">
  #viewSchedule{
    background:#F8F8F8;
    min-height: 100vh;
    position: relative;
    padding-bottom: 0.3rem;
    .title {
      text-align: center;
      background: white;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px solid #F2F4FB;
      position: relative;

      i {
        position: absolute;
        left: 20px;
        font-size: 20px;
      }
    }
    .withdraw_mount_text{
      text-align: center;
      font-size: 12px;
      margin: 30px 0 10px;
    }
    .withdraw_mount{
      font-size: 14px;
      color: #3a8ee6;
      text-align: center;
      margin: 10px 0 30px;
      span{
        font-size: 28px;
        font-weight: 500;
        margin-right: 6px;

      }
    }
    .withdraw_content{
      width: 93%;
      margin: 6px auto;
      background: #fff;
      padding: 0 15px 15px;
      box-sizing: border-box;
      border-radius: 15px;
      position: relative;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
      .circle{
        :nth-child(1){
          position: absolute;
          top: 1.15rem;
          left: -1px;
          z-index: 1;
          width:8px;
          height:16px;
          background-color:#F8F8F8;
          border-top: 1px solid rgba(122, 122, 122, 0.1);
          border-right: 1px solid rgba(122, 122, 122, 0.1);
          border-bottom: 1px solid rgba(122, 122, 122, 0.1);
          border-radius:0 20px 20px 0; /* 左上、右上、右下、左下 */
        }
        :nth-child(2){
          position: absolute;
          top: 1.15rem;
          right: -1px;
          z-index: 1;
          width:8px;
          height:16px;
          background-color:#F8F8F8;
          border-radius:20px 0 0 20px; /* 左上、右上、右下、左下 */
          border-top: 1px solid rgba(122, 122, 122, 0.1);
          border-left: 1px solid rgba(122, 122, 122, 0.1);
          border-bottom: 1px solid rgba(122, 122, 122, 0.1);

        }
      }
      .withdraw_detail_title{
        font-size: 18px!important;
        font-weight: 600;
      }
      .item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.44rem 0;
        font-size: 14px;
        border-bottom: 1px dotted #E9E9E9;
        div{
          color: gray;
        }
        >div:nth-child(1){
          color: #8E97A6;
        }
      }

    }
    #btn{
      @include defaultBtn
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/Audit/viewSchedule.vue